import React from "react";
import { Box, Container, Typography, Divider, Grid2 } from "@mui/material";

const Education: React.FC = () => {
  return (
    <Box id="resume-skill" sx={{ py: 8, bgcolor: "#f5f5f5" }}>
      <Container>
        <Grid2 container spacing={4}>
          <Grid2 size={{ xs: 12 }}>
            <Typography variant="h2" gutterBottom sx={{ textAlign: "center" }}>
              My education
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            {" "}
            <Typography
              variant="h5"
              sx={{ textAlign: { xs: "center", md: "left" } }}
            >
              My entire educational career was driven by Software Engineering.
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            {" "}
            <Box>
              <Box sx={{ mb: 4 }}>
                <Typography variant="h3" sx={{ fontWeight: "bold" }}>
                  M.Sc. in Computer Science
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Campina Grande, Brazil / Mar. 2012 - Nov. 2014
                </Typography>
                <Divider sx={{ my: 1 }} />
                <Typography variant="body1">
                  Universidade Federal de Campina Grande (UFCG), BRAZIL.
                </Typography>
              </Box>
              <Box sx={{ mb: 4 }}>
                <Typography variant="h3" sx={{ fontWeight: "bold" }}>
                  B.Sc. in Computer Science
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Campina Grande, Brazil / Apr. 2008 - Dec. 2011
                </Typography>
                <Divider sx={{ my: 1 }} />
                <Typography variant="body1">
                  Universidade Federal de Campina Grande (UFCG), BRAZIL.
                </Typography>
              </Box>
            </Box>
          </Grid2>
        </Grid2>
      </Container>
    </Box>
  );
};

export default Education;
